module.exports = __webpack_public_path__ + "img/drt3.1fc23537.png";